import React from 'react'
import customRequest from '../../../helpers/customRequest'
import getURLParams from '../../../helpers/getURLParams'
import message from '../../../components/message/message'
import redirect from '../../../components/redirect/redirect'
import { initializeFormValidation } from '../../../helpers/forms/form-validation'


class Archive extends React.Component
{
    state = {
        student: ""
    }
    componentDidMount()
    {
        var params = getURLParams()
        this.setState({student: params.student})
        initializeFormValidation(this.onSubmit)
    }

    onSubmit = (event) => {
        customRequest.post('/api/students/archive', {
            studentName: this.state.student
        })
        .then(({data}) =>
        {
            message.clear()
            if (data.valid) {
                redirect.send("/students")
                message.success("Your student has been successfully archived.")
            }
            else {
                message.success(data.message)
            }

        })
    }

    render()
    {
        var {student} = this.state
        return (
            <React.Fragment>
                <h1>Archive Student</h1>

                <div class = "row subheader-text">
                    <div class = "col-sm-10 offset-sm-1 col-md-8 offset-md-2">
                        <p>Please note that archiving a student <strong>cannot</strong> be undone online and <strong>a fee will be assessed to return this student to active status.</strong> If you would like to restore an archived student, please <a href = "https://greatleaps.com/index.php?main_page=contact_us">contact us using our contact form</a> for assistance.</p>
                    </div>
                </div>

                <form class = "form-horizontal prevent-next-submit" noValidate method = "post">
                    <div class = "form-group row">
                        <label class = "d-none d-sm-inline col-sm-6 control-label text-right">Name</label>
                        
                        <div class = "col-sm-6">
                            <p class = "form-control-static text-left text-center-xs break-words">{student}</p>
                        </div>
                    </div>
                    
                    <button type = "button" class = "btn btn-secondary btn-lg" data-toggle = "modal" data-target = "#warning-modal">Archive</button>
                    
                    <div class = "modal fade" id = "warning-modal" role = "dialog">
                        <div class = "modal-dialog modal-md">
                            <div class = "modal-content">
                                <form class = "form-horizontal prevent-next-submit form-validate" noValidate method = "post">
                                    <div class = "modal-header">
                                        <h4 class = "modal-title">Warning</h4>
                                        <button type = "button" class = "close" data-dismiss = "modal">&times;</button>
                                    </div>
                                    <div class = "modal-body text-left">
                                        <p>This action will move the selected student to the archives.</p>
                                    <p>A <strong>fee of $25</strong> will be assessed to return this student from archived to active status. Are you sure you want to archive {student}?</p>
                                    </div>
                                    <div class = "modal-footer">
                                        <button type = "button" class = "btn modal-btn btn-secondary button-inline" data-dismiss = "modal">Cancel</button>
                                        <button onClick={this.onSubmit} class = "btn modal-btn btn-danger" data-dismiss = "modal">Archive</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </form>
            </React.Fragment>
        )
    }
}

export default Archive
